import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface PlanAccount {
  name?: string;
}


interface Props {
  accountId?: string;
}

const useGetPlanAccountQuery = ({ accountId }: Props) => {
  const { data, isLoading, isError } = useQuery(
    [API_URL.PLANS_ACCOUNTS, accountId],
    () =>
      api.get(API_URL.PLANS_ACCOUNTS, {
        params: {
          account_id: accountId,
        },
      }),
    {
      enabled: !!accountId,
    }
  );

  const planAccount: PlanAccount | undefined = useMemo(() => {
    return {
      name: data?.data?.name?.name,
    };
  }, [data]);

  return {
    planAccount,
    isLoading,
    isError,
  };
};

export default useGetPlanAccountQuery;
